if(getShoptetDataLayer('customer').registered){
    $('.next-to-carousel-banners').remove()
    $('.welcome-wrapper .titlepage').remove()
    $('#products-1, .homepage-products-heading-1').remove()
    $('.carousel-inner .item img').each(function(){
        if($(this).attr('alt').indexOf('b2c') !== -1){
            $(this).closest('.item').remove()
        }
    })
}
else{
    $('#products-9, .homepage-products-heading-9').remove()
    $('.carousel-inner .item img').each(function(){
        if($(this).attr('alt').indexOf('b2b') !== -1){
            $(this).closest('.item').remove()
        }
    })
}

